import { getErrorMessageByValidationModel } from "@/lib/form-validation.js";

// Shared helpers for forms built on NylonFormField. Keeps the blur-validation
// policy ("reward early, punish late") in one place: fields are touched when
// the user leaves a field they've actually filled in — touching on every
// keystroke warns about half-typed emails, and touching empty fields on blur
// punishes tabbing through the form. Submit still $touches everything, and
// once a field is dirty Vuelidate re-evaluates live as they type, so an
// error clears the moment it's fixed.
export default {
  methods: {
    errorMessage(validationModel) {
      return getErrorMessageByValidationModel(validationModel, null);
    },

    onFieldBlur(validationModel, value) {
      if (value) {
        validationModel.$touch();
      }
    },
  },
};
